import { render, staticRenderFns } from "./BaseStorableList.vue?vue&type=template&id=195eb937&scoped=true&"
import script from "./BaseStorableList.vue?vue&type=script&lang=ts&"
export * from "./BaseStorableList.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStorableList.vue?vue&type=style&index=0&id=195eb937&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195eb937",
  null
  
)

export default component.exports